import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  background: transparent;
  height: 100vh;
  padding: 0 5rem;
  gap: 1rem;
`;

export function ErrorPage() {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Helmet title="Dashboard Error" />
      <h2>{t('pages.cores.errors.fallBack.title')}</h2>
      <h3>{t('pages.cores.errors.fallBack.description')}</h3>
    </Wrapper>
  );
}
